import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom';
import {constants} from "../config/constants";
// @ts-ignore
import Cookies from 'js-cookie'

export const AdminRoute = ({children}) => {
    const user = useSelector(state => state.auth);
    let access_token = Cookies.get(constants.zynity_api_access_token_cookie_name);
    if(access_token == undefined) {
        return <Navigate to="/site/login" replace />;
    }

    return user.visibility_profile === 'Zadmin'
        ? children
        : <Navigate to="/" />
}
